import React, {
  useEffect,
  useState,
} from "react";

import { useNavigate } from "react-router-dom";

import {
  Swiper,
  SwiperSlide,
} from "swiper/react";

import {
  Autoplay,
  Pagination,
} from "swiper/modules";

import {
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";

import eventImg from "../assets/event.jpg";
import newsImg from "../assets/news.jpg";

import "swiper/css";
import "swiper/css/pagination";

const News = () => {
  const navigate =
    useNavigate();

  const [events, setEvents] =
    useState([]);

  const [news, setNews] =
    useState([]);

  const [newsIndex, setNewsIndex] =
    useState(0);

  const [eventIndex, setEventIndex] =
    useState(0);

  // FETCH EVENTS
  useEffect(() => {
    fetch(
      "https://stjosephweb.ilakshyaerp.in/api/events"
    )
      .then((res) =>
        res.json()
      )
      .then((data) =>
        setEvents(
          Array.isArray(data)
            ? data
            : []
        )
      )
      .catch(() =>
        console.log(
          "Event fetch error"
        )
      );
  }, []);

  // FETCH NEWS
  useEffect(() => {
    fetch(
      "https://stjosephweb.ilakshyaerp.in/api/news"
    )
      .then((res) =>
        res.json()
      )
      .then((data) =>
        setNews(
          Array.isArray(data)
            ? data
            : []
        )
      )
      .catch(() =>
        console.log(
          "News fetch error"
        )
      );
  }, []);

  // SHORT TEXT
  const shortText = (
    text
  ) => {
    if (!text) return "";

    const words =
      text.split(" ");

    return (
      words
        .slice(0, 4)
        .join(" ") + "..."
    );
  };

  // NEWS ARROWS
  const nextNews = () => {
    if (news.length > 0) {
      setNewsIndex(
        (prev) =>
          (prev + 1) %
          news.length
      );
    }
  };

  const prevNews = () => {
    if (news.length > 0) {
      setNewsIndex(
        (prev) =>
          prev === 0
            ? news.length - 1
            : prev - 1
      );
    }
  };

  // EVENT ARROWS
  const nextEvent = () => {
    if (events.length > 0) {
      setEventIndex(
        (prev) =>
          (prev + 1) %
          events.length
      );
    }
  };

  const prevEvent = () => {
    if (events.length > 0) {
      setEventIndex(
        (prev) =>
          prev === 0
            ? events.length - 1
            : prev - 1
      );
    }
  };

  return (
    <section className="w-full bg-[#f7f9fc] py-20 overflow-x-hidden">

      <div className="max-w-7xl mx-auto px-5 md:px-10">

        {/* HEADING */}
        <div className="text-center mb-16">

          <span className="text-[#D4A017] uppercase tracking-[5px] text-sm font-bold">

            Latest Updates

          </span>

          <h2 className="text-4xl md:text-5xl font-extrabold text-[#072F5F] mt-4">

            NEWS AND
            <span className="text-[#0B4F9C]">
              {" "}
              EVENTS
            </span>

          </h2>

        </div>

        {/* MAIN GRID */}
        <div className="grid grid-cols-1 lg:grid-cols-[1.1fr_1.4fr] gap-10 items-start">

          {/* LEFT BIG SLIDER */}
          <div className="overflow-hidden rounded-[35px] shadow-2xl">

            <Swiper
              modules={[
                Autoplay,
                Pagination,
              ]}
              autoplay={{
                delay: 4000,
              }}
              loop={true}
              pagination={{
                clickable: true,
              }}
            >

              {/* NEWS */}
              <SwiperSlide>

                <div className="relative h-[320px] md:h-[500px]">

                  <img
                    src={newsImg}
                    alt="News"
                    className="w-full h-full object-cover"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent"></div>

                  {/* CONTENT */}
                  <div className="absolute bottom-0 left-0 p-8">

                    <h3 className="text-4xl md:text-5xl font-extrabold text-white">

                      News

                    </h3>

                    <p className="text-gray-200 mt-3 text-lg max-w-md">

                      A glimpse into school traditions
                      and values...

                    </p>

                  </div>

                  {/* ARROW */}
                  <button
                    onClick={() =>
                      navigate(
                        "/news"
                      )
                    }
                    className="absolute bottom-8 left-8 w-14 h-14 rounded-full bg-white text-[#072F5F] text-2xl flex items-center justify-center shadow-xl hover:bg-[#0B4F9C] hover:text-white transition-all duration-300"
                  >

                    →

                  </button>

                </div>

              </SwiperSlide>

              {/* EVENT */}
              <SwiperSlide>

                <div className="relative h-[320px] md:h-[500px]">

                  <img
                    src={eventImg}
                    alt="Events"
                    className="w-full h-full object-cover"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent"></div>

                  {/* CONTENT */}
                  <div className="absolute bottom-0 left-0 p-8">

                    <h3 className="text-4xl md:text-5xl font-extrabold text-white">

                      Events

                    </h3>

                    <p className="text-gray-200 mt-3 text-lg max-w-md">

                      Celebrating excellence and
                      achievements...

                    </p>

                  </div>

                  {/* ARROW */}
                  <button
                    onClick={() =>
                      navigate(
                        "/events"
                      )
                    }
                    className="absolute bottom-8 left-8 w-14 h-14 rounded-full bg-white text-[#072F5F] text-2xl flex items-center justify-center shadow-xl hover:bg-[#0B4F9C] hover:text-white transition-all duration-300"
                  >

                    →

                  </button>

                </div>

              </SwiperSlide>

            </Swiper>

          </div>

          {/* RIGHT SIDE CARDS */}
          <div className="flex flex-col gap-10">

            {/* NEWS CARD */}
            {news.length === 0 ? (
              <div className="bg-white rounded-[30px] p-10 shadow-lg text-center">

                <h4 className="text-2xl font-bold text-[#072F5F]">

                  🚫 No News Available

                </h4>

              </div>
            ) : (
              <div className="relative bg-white rounded-[30px] shadow-xl p-5 flex flex-col md:flex-row items-center gap-6">

                {/* LEFT ARROW */}
                <button
                  className="absolute -left-5 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-[#21468B] text-white flex items-center justify-center shadow-xl"
                  onClick={
                    prevNews
                  }
                >

                  <FaChevronLeft />

                </button>

                {/* IMAGE */}
                <img
                  src={`https://stjosephweb.ilakshyaerp.in/uploads/news/${news[newsIndex]?.image}`}
                  alt=""
                  className="w-full md:w-[220px] h-[180px] object-cover rounded-[20px]"
                />

                {/* CONTENT */}
                <div className="flex-1">

                  <span className="text-[#D4A017] uppercase tracking-[3px] text-xs font-bold">

                    Today News

                  </span>

                  <h3 className="text-2xl font-bold text-[#072F5F] mt-3">

                    {shortText(
                      news[
                        newsIndex
                      ]?.title
                    )}

                  </h3>

                  <button
                    onClick={() =>
                      navigate(
                        "/news"
                      )
                    }
                    className="mt-5 bg-black hover:bg-[#0B4F9C] text-white px-5 py-3 rounded-lg text-sm font-semibold transition-all duration-300"
                  >

                    READ MORE

                  </button>

                </div>

                {/* RIGHT ARROW */}
                <button
                  className="absolute -right-5 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-[#21468B] text-white flex items-center justify-center shadow-xl"
                  onClick={
                    nextNews
                  }
                >

                  <FaChevronRight />

                </button>

              </div>
            )}

            {/* EVENT CARD */}
            {events.length === 0 ? (
              <div className="bg-white rounded-[30px] p-10 shadow-lg text-center">

                <h4 className="text-2xl font-bold text-[#072F5F]">

                  🚫 No Events Available

                </h4>

              </div>
            ) : (
              <div className="relative bg-white rounded-[30px] shadow-xl p-5 flex flex-col md:flex-row items-center gap-6">

                {/* LEFT ARROW */}
                <button
                  className="absolute -left-5 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-[#21468B] text-white flex items-center justify-center shadow-xl"
                  onClick={
                    prevEvent
                  }
                >

                  <FaChevronLeft />

                </button>

                {/* IMAGE */}
                <img
                  src={`https://stjosephweb.ilakshyaerp.in/uploads/events/${events[eventIndex]?.image}`}
                  alt=""
                  className="w-full md:w-[220px] h-[180px] object-cover rounded-[20px]"
                />

                {/* CONTENT */}
                <div className="flex-1">

                  <span className="text-[#D4A017] uppercase tracking-[3px] text-xs font-bold">

                    Upcoming Event

                  </span>

                  <h3 className="text-2xl font-bold text-[#072F5F] mt-3">

                    {shortText(
                      events[
                        eventIndex
                      ]?.narration
                    )}

                  </h3>

                  <button
                    onClick={() =>
                      navigate(
                        "/events"
                      )
                    }
                    className="mt-5 bg-black hover:bg-[#0B4F9C] text-white px-5 py-3 rounded-lg text-sm font-semibold transition-all duration-300"
                  >

                    READ MORE

                  </button>

                </div>

                {/* RIGHT ARROW */}
                <button
                  className="absolute -right-5 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-[#21468B] text-white flex items-center justify-center shadow-xl"
                  onClick={
                    nextEvent
                  }
                >

                  <FaChevronRight />

                </button>

              </div>
            )}

          </div>

        </div>

      </div>

    </section>
  );
};

export default News;